var firebase = require('../firebase');
var toastr = require('toastr');
var fetch = require('isomorphic-fetch');
var toastr = require('toastr');

// var { fbStorage, fbDb } = firebase;

var { fbDb } = firebase;

module.exports = {
	fetching: function() {
		return {
			type: "DATA_FETCHING"
		};
	},

	fetched: function() {
		return {
			type: "DATA_FETCHED"
		};
	},

	createOrderSuccess: function(order) {
		return {
			type: "CREATE_ORDER_SUCCESS",
			payload: order
		};
	},

	loadOrdersSuccess: function(orders) {
		return {
			type: "LOAD_ORDERS_SUCCESS",
			payload: orders
		};
	},

	updateOrderSuccess: function(order) {
		return {
			type: "UPDATE_ORDER_SUCCESS",
			payload: order
		};
	},

	deleteOrderSuccess: function(order) {
		return {
			type: "DELETE_ORDER_SUCCESS",
			payload: order
		};
	},

	filterOrders: function(type) {
		return {
			type: "FILTER_ORDERS",
			payload: type
		};
	},

	unloadOrders: function() {
		return {
			type: "UNLOAD_ORDERS"
		}
	},

	pushUserOrder(key, value) {
		var path = 'users/' + key + '/myOrders';

		return new Promise((resolve, reject) => {
			fbDb.ref(path)
			.update(value, error => error ? reject(error) : resolve());
		});
	},

	push(data) {
		return new Promise((resolve, reject) => {
		  fbDb.ref('orders')
		    .push(data, error => error ? reject(error) : resolve());
		});
	},

	update: function(key, data) {
		return new Promise((resolve, reject) => {
			fbDb.ref(`orders/${key}`)
			.update(data, error => error ? reject(error) : resolve());
		});
	},

	updateOrderCount: function(value) {
		return new Promise((resolve, reject) => {
			fbDb.ref('lastOrder')
			.set(value, error => error ? reject(error) : resolve());
		});
	},

	remove: function(key, clientId, courierId) {
		return new Promise((resolve, reject) => {
			fbDb.ref(`orders/${key}`)
			.remove(error => error ? reject(error) : resolve());

			fbDb.ref(`users/${clientId}/myOrders/${key}`)
			.remove(error => error ? reject(error) : resolve());

			if(courierId != "") {
				fbDb.ref(`couriers/${courierId}/orders/${key}`)
				.remove(error => error ? reject(error) : resolve());
			}
		});
	},

	_removeCourierOrder: function(key, clientId, courierId) {
		return new Promise((resolve, reject) => {
			fbDb.ref(`orders/${key}/status`)
			.set(1, error => error ? reject(error) : resolve());
			
			fbDb.ref(`orders/${key}/courier`)
			.set("", error => error ? reject(error) : resolve());

			fbDb.ref(`users/${clientId}/myOrders/${key}/status`)
			.set(1, error => error ? reject(error) : resolve());

			fbDb.ref(`couriers/${courierId}/orders/${key}`)
			.remove(error => error ? reject(error) : resolve());
		});
	},

	_finishOrder: function(key, clientId, courierId) {
		return new Promise((resolve, reject) => {
			fbDb.ref(`orders/${key}/status`)
			.set(3, error => error ? reject(error) : resolve());

			fbDb.ref(`users/${clientId}/myOrders/${key}/status`)
			.set(3, error => error ? reject(error) : resolve());

			fbDb.ref(`couriers/${courierId}/orders/${key}/status`)
			.set(3, error => error ? reject(error) : resolve());
		});
	},

	_courierOrder: function(key, clientId, idx, cOrder) {
		return new Promise((resolve, reject) => {
			fbDb.ref('orders/'+key+'/status')
			.set(2, error => error ? reject(error) : resolve());

			fbDb.ref('orders/'+key+'/courier')
			.set(idx, error => error ? reject(error) : resolve());

			fbDb.ref('orders/'+key+'/courierValue')
			.set(cOrder.value, error => error ? reject(error) : resolve());

			fbDb.ref('users/'+clientId+'/myOrders/'+key+'/status')
			.set(2, error => error ? reject(error) : resolve());

			fbDb.ref('couriers/'+idx+'/orders/'+key)
			.set(cOrder, error => error ? reject(error) : resolve());
		});
	},

	getCourier: function(courierId) {
		var ref = fbDb.ref('couriers/'+courierId), 
			courier = {};

		ref.once("value", (snap) => {
			var data = snap.val(),
				user = data ? data.info : null;

			if (user)
				courier = Object.assign(
					{}, 
					{ 
					  idCourier: courierId, 
					  nameCourier: user.name, 
					  phoneCourier: user.phone
					}
				)
		});

		return courier;
	},

	getClient: function(clientId) {
		var ref = fbDb.ref('users/'+clientId), 
			client = {};

		ref.once("value", (snap) => {
			var user = snap.val();

			if (user && user.personalData) {
				client = Object.assign(
					{}, 
					{
					idClient: clientId, 
					nameClient: user.personalData.name, 
					phoneClient: user.personalData.phone,
					typeClient: user.userType
					}
				)
			}
		});

		return client;
	},

	/*getCourierAvatar: function(data) {
		return {
			type: "UPDATE_AVATAR_COURIER",
			payload: data
		}
	},

	getCourierAvatar: function(key, order) {
		var me = this;

		return function(dispatch) {
			fbStorage.ref('images/' + key + '/profile.jpg').getDownloadURL()
			.then((url) => {
				dispatch(me.getCourierAvatar({
					order: order,
					avatar: url
				}))
			}).catch((error) => {});
		}
	},*/

	formatAddress: function(street, number, complement, verificationCode) {
		return !street ? null : street + ', ' + number + ' - ' + complement + '. Código segurança: ' + verificationCode;
	},

	getOriginDestinationAddress: function(adresses) {
		var me = this,
			last = adresses.length,
			aPoint = adresses[0],
			bPoint = adresses[1],
			cPoint = adresses.length > 2 ? adresses[2] : {street: '', number: '', complement: '', verificationCode: ''},
			dPoint = adresses.length > 3 ? adresses[3] : {street: '', number: '', complement: '', verificationCode: ''};
		
		return {
			aPoint: me.formatAddress(aPoint.street, aPoint.number, aPoint.complement, aPoint.verificationCode),
			bPoint: me.formatAddress(bPoint.street, bPoint.number, bPoint.complement, bPoint.verificationCode),
			cPoint: me.formatAddress(cPoint.street, cPoint.number, cPoint.complement, cPoint.verificationCode),
			dPoint: me.formatAddress(dPoint.street, dPoint.number, dPoint.complement, dPoint.verificationCode)
		}
	},

	unwrapOrder: function(snap) {
		var me = this, 
			dataOrder = snap.val(), 
			client = me.getClient(dataOrder.client), 
			courier = dataOrder.courier ? me.getCourier(dataOrder.courier) : {},
			addresses = me.getOriginDestinationAddress(dataOrder.addresses), 
			{ 
				createdAt, 
				estimatedTime, 
				order, status, 
				paymentStatus,
				paymentCourierStatus,
				value,
				courierValue,
				paymentMethod,
				deliveryType,
				packageType,
				totalDistance,
				returnToOrigin
			} = dataOrder;

		return Object.assign({}, 
			client,
			courier,
			addresses,
			{	id: snap.key,
				createdAt: createdAt,
				estimatedTime: estimatedTime,
				status: status,
				paymentStatus: paymentStatus,
				paymentCourierStatus: paymentCourierStatus,
				order: order,
				value: value,
				courierValue: courierValue,
				paymentMethod: paymentMethod,
				courierAvatar: null,
				courierLocation: dataOrder.courier,
				directions: dataOrder.addresses,
				deliveryType: deliveryType,
				packageType: packageType,
				returnToOrigin: returnToOrigin ? "Sim" : "Não",
				totalDistance: totalDistance
			}
		);
	},

	locationReload: function() {
		location.reload();
	},

	loadOrders: function() {
		var me = this;

		return function(dispatch) {
			var ref = fbDb.ref('orders').orderByChild("createdAt"),//.limitToLast(100),
			//var ref = fbDb.ref('orders').orderByChild("createdAt").limitToLast(2),
			//var ref = fbDb.ref('orders').orderByChild("status").endAt(2),
				list = [],
				initialized = false;

			ref.once('value', (orders) => {
				initialized = true;
				dispatch(me.loadOrdersSuccess(list));
			});

			ref.on('child_added', snap => {
				var order = me.unwrapOrder(snap);

				/*if (initialized)
					dispatch(me.createOrderSuccess(order));
				else*/
					list.unshift(order);
				if(initialized) {
					toastr.success('Novo pedido encontrado!');
					var snd = new Audio("http://www.avamobile.com.br/api/ajato_email/success.wav");  
    				snd.play();
    				window.setTimeout(me.locationReload, 10000);
				}
			});

			ref.on('child_changed', snap => {
				var order = me.unwrapOrder(snap);

				dispatch(me.updateOrderSuccess(order));
			});

			ref.on('child_removed', snap => {
				var order = me.unwrapOrder(snap);

				dispatch(me.deleteOrderSuccess(order));
			});

			me._unsubscribe = () => ref.off();

			dispatch(me.fetching());
		}
	},

	unsubscribe: function() {
		var me = this;

		return function(dispatch) {
			me._unsubscribe();
			
			dispatch(me.unloadOrders());
		};
	},

	removeCourierOrder: function(key, clientId, courierId) {
		var me = this;

		return function(dispatch) {
			me._removeCourierOrder(key, clientId, courierId)
			.then(() => {
				toastr.success('O pedido foi removido do entregador.');
			})
			.catch(() => {
				toastr.error('Ocorreu um erro ao realizar a operação.');
			})
		}
	},

	finishOrder: function(key, clientId, courierId) {
		var me = this;

		return function(dispatch) {
			me._finishOrder(key, clientId, courierId)
			.then(() => {
				toastr.success('O pedido foi finalizado com sucesso.');
			})
			.catch(() => {
				toastr.error('Ocorreu um erro ao realizar a operação.');
			})
		}
	},

	courierOrder: function(key, clientId, idx, cOrder) {
		var me = this;

		return function(dispatch) {
			me._courierOrder(key, clientId, idx, cOrder)
			.then(() => {
				toastr.success('O pedido foi associado com sucesso.');
			})
			.catch(() => {
				toastr.error('Ocorreu um erro ao realizar a operação.');
			})
		}
	},

	updateOrder: function(key, data) {
		var me = this;

		return function(dispatch) {
			me.update(key, data)
			.then(() => {
				toastr.success('O pedido foi atualizado com sucesso.');
			})
			.catch(() => {
				toastr.error('Ocorreu um erro ao atualizar o registro.');
			})
		}
	},

	removeOrder: function(key, clientId, courierId) {
		var me = this;

		return function(dispatch) {
			me.remove(key, clientId, courierId)
			.then(() => {
				toastr.success('O pedido foi excluído com sucesso.');
			})
			.catch(() => {
				toastr.error('Ocorreu um erro ao remover o registro.');
			})
		}
	},

	newOrderCount: function(ref, callback) {
	  	ref.transaction((count) => {
			count++;
			return count;
		}, callback, false);
	},

	createOrderRequest: function(data) {
		var me = this;

		return function(dispatch) {
			//fetch('https://www.avamobile.com.br/api/ajato_mercadopago_teste/get_user.php?email=' + data.userEmail)
			fetch('https://www.avamobile.com.br/api/ajato_mercadopago/get_user.php?email=' + data.userEmail)
		    .then(function(response) {
		        if (response.status >= 400)
		            throw new Error("Bad response from server");

		        return response.json();
		    })
		    .then(function(customer) {
		    	var token = data.token,
		    		customer_id = customer.id,
		    		method = data.payment_method_id,
		    		amount = data.value,
		    		params = '?token='+token+'&customer_id='+customer_id+'&payment_method_id='+method+'&transaction_amount='+amount;

		    	//fetch('https://www.avamobile.com.br/api/ajato_mercadopago_teste/new_payment.php' + params)
		    	fetch('https://www.avamobile.com.br/api/ajato_mercadopago/new_payment.php' + params)
			    .then(function(resp) {
			        if (resp.status >= 400)
			            throw new Error("Bad response from server");
			        
			        return resp.json();
			    })
			    .then(function(payment) {
			    	if (payment.status === "approved") {
			    		dispatch(me.createOrder(Object.assign({}, data, {status: 1})));
			    	} else {
			    		toastr.error('Ocorreu um erro ao processar a solicitação. Por favor, tente novamente.');
			    		dispatch(me.fetched());
			    	}
			    });
		    });

		    dispatch(me.fetching());
		}
	},

	createOrder: function(data) {
		var me = this, ref = fbDb.ref('lastOrder');

		return function(dispatch) {
			me.newOrderCount(ref, () => {
				ref.once('value', (snap) => {
					var count = snap.val(),
						order = {
							addresses: {
								0: {
									complement: data.originComplement,
									description: data.originWhatTodo,
									lat: data.origin.lat,
									lon: data.origin.lng,
									number: data.originNumber,
									status: 0,
									street: data.originStreet,
									verificationCode: data.originVCode
								},

								1: {
									complement: data.destinationComplement,
									description: data.destinationWhatTodo,
									lat: data.destination.lat,
									lon: data.destination.lng,
									number: data.destinationNumber,
									status: 0,
									street: data.destinationStreet,
									verificationCode: data.destinationVCode
								}
							},

							courier: "",

							client: data.userId,
							createdAt: data.createdAt,
							estimatedTime: data.estimatedTime,
							order: count,
							deliveryType: parseInt(data.deliveryType, 10),
							packageType: parseInt(data.packageType, 10),
							paymentData: '',
							paymentMethod: data.paymentMethod,
							returnToOrigin: data.returnToOrigin,
							status: data.status,
							totalDistance: data.totalDistance,
							value: data.value,
							rate: 0,
							orderType: 0
						};

						if(data.waypoint01) {
							order.addresses[2] = {
								complement: data.waypoint01Complement,
								description: data.waypoint01WhatTodo,
								lat: data.waypoint01.lat,
								lon: data.waypoint01.lng,
								number: data.waypoint01Number,
								status: 0,
								street: data.waypoint01Street,
								verificationCode: data.waypoint01VCode
							};
						}

						if(data.waypoint02) {
							order.addresses[3] = {
								complement: data.waypoint02Complement,
								description: data.waypoint02WhatTodo,
								lat: data.waypoint02.lat,
								lon: data.waypoint02.lng,
								number: data.waypoint02Number,
								status: 0,
								street: data.waypoint02Street,
								verificationCode: data.waypoint02VCode
							};
						}

					var refOrders = fbDb.ref('orders');

					refOrders.push(order)
					.then((response) => {
						me.pushUserOrder(data.userId, {[response.key] : {
							createdAt: data.createdAt,
							estimatedTime: data.estimatedTime,
							order: count,
							status: data.status,
							totalDistance: data.totalDistance,
							value: data.value
						}})
						.then(() => {
							toastr.success('Pedido criado com sucesso!');
							dispatch(me.fetched());
						}).catch((error) => {
							toastr.error('Ocorreu um erro ao processar sua solicitação.');
							dispatch(me.fetched());
						})

					}).catch((e) => {
						toastr.error('Ocorreu um erro ao processar sua solicitação.');
						dispatch(me.fetched());
					});
				})
			});

			dispatch(me.createOrderSuccess());
		}
	}
};


// WEBPACK FOOTER //
// ./src/actions/orderActions.js